import { faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const RemoveCart =({cancelRemove,removeAllItems,selectedItem,confirmRemove})=>{
    return(
        <div className="app-addons">
        <div className="app-modal">
          <div className="modal-fixed-container">
            <div className="modal-backdrop opened"></div>
            <div className="modal-basic modal-base-style">
              <div className="modal-header">
                <div>
                  <div className="title">Are you sure?</div>
                </div>
                <FontAwesomeIcon className="far flex-wrap m-l-a close-icon" icon={faTimes} onClick={cancelRemove} />
              </div>
              <div className="body pre-line">
                <div className="p-l-20 p-r-20">
                  {selectedItem
                    ? 'Remove this item from cart?'
                    : 'Remove all products in cart?'}
                </div>
              </div>
              <div className="bottom-buttons">
                <button className="btns btn-brd" onClick={cancelRemove}>Cancel</button>
                <button className="btns btn-primary" onClick={selectedItem ? confirmRemove : removeAllItems}>OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default RemoveCart